import { createSelector } from '@reduxjs/toolkit';

import { IState } from '../../store';

const tagsMapping: Record<string, string> = {
  pledge: 'encumbranceRealty',
  trades: 'tradeRealty',
};

export const selectAgentLists = createSelector(
  (state: IState) => state.offerData.agent?.agentLists || [],
  (state: IState) => state.offerData.offer?.bargainTerms?.tags || [],
  (agentLists, tags) => {
    const result = [...agentLists];

    tags.forEach(rawTag => {
      const tag: string | undefined = tagsMapping[rawTag];
      if (tag && !result.includes(tag)) {
        result.push(tag);
      }
    });

    return result;
  },
);
